import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
interface Decision {
  id: string;
  time: string;
  actor: string;
  action: string;
  result: string;
}
interface RiskDecisionsProps {
  decisions: Decision[];
  phase: number;
  isRecomputing?: boolean;
}
export function RiskDecisions({
  decisions,
  phase,
  isRecomputing
}: RiskDecisionsProps) {
  const getActorColor = (actor: string) => {
    if (actor.includes('committee')) return 'text-purple-400';
    if (actor.includes('system')) return 'text-blue-400';
    return 'text-emerald-400';
  };
  return <div className={`bg-slate-900 border rounded p-3.5 h-full flex flex-col transition-colors ${isRecomputing ? 'border-emerald-500/50' : 'border-slate-800'}`} data-id="element-165">
      <div className="flex items-center justify-between mb-3 pt-2" data-id="element-166">
        <h3 className="text-base font-semibold text-slate-300 tracking-tight" data-id="element-167">
          Risk Decisions
        </h3>
        <FileTextIcon size={16} className="text-slate-600" data-id="element-168" />
      </div>

      <div className="flex-1 overflow-y-auto space-y-2.5 max-h-[280px]" data-id="element-169">
        <AnimatePresence mode="popLayout" data-id="element-170">
          {decisions.length === 0 && phase < 6 && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="text-[11px] text-slate-600 text-center py-6" data-id="element-171">
              No recent decisions
            </motion.div>}

          {decisions.map((decision, index) => <motion.div key={decision.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          delay: index * 0.1,
          duration: 0.2
        }} className="border border-slate-800 rounded p-2.5 bg-slate-900/50" data-id="element-172">
              <div className="flex items-center justify-between mb-1.5" data-id="element-173">
                <span className="text-[10px] text-slate-600 font-mono" data-id="element-174">
                  {decision.time}
                </span>
                <span className={`text-[10px] font-semibold ${getActorColor(decision.actor)}`} data-id="element-175">
                  {decision.actor}
                </span>
              </div>
              <div className="text-[11.5px] text-slate-300 mb-1 leading-snug" data-id="element-176">
                {decision.action}
              </div>
              <div className="text-[10px] text-slate-500" data-id="element-177">
                {decision.result}
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>

      {phase >= 6 && decisions.length > 0 && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.2
    }} className="mt-3 pt-3 border-t border-slate-800" data-id="element-178">
          <div className="text-[10px] text-slate-400" data-id="element-179">
            All decisions logged for audit.
          </div>
        </motion.div>}
    </div>;
}